import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
// Components
import Calendar from "primevue/calendar";
import SvgIcon from "./SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecCalendar',
    props: /*@__PURE__*/ _mergeModels({
        name: { default: undefined },
        id: { default: undefined },
        iconDisplay: { default: "button" },
        showTime: { type: Boolean },
        dateFormat: { default: "mm/dd/yy" },
        hourFormat: { default: "12" },
        minDate: { default: undefined },
        maxDate: { default: undefined },
        iconColor: { default: "var(--s-d-80)" },
        iconSize: { default: "1rem" },
        noIcon: { type: Boolean }
    }, {
        "modelValue": { required: true },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const date = _useModel(__props, "modelValue");
        const inputProps = computed(() => {
            const { name, id } = props;
            if (!id && !name)
                return undefined;
            return {
                id,
                name
            };
        });
        const pt = computed(() => ({
            root: {
                class: ["rec-calendar", { "rec-calendar--active": date.value }]
            },
            panel: "rec-calendar__datepicker"
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Calendar), {
                modelValue: date.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((date).value = $event)),
                "show-time": _ctx.showTime,
                "icon-display": _ctx.iconDisplay,
                "min-date": _ctx.minDate,
                "max-date": _ctx.maxDate,
                pt: pt.value,
                "hour-format": _ctx.hourFormat,
                "date-format": _ctx.dateFormat,
                "input-props": inputProps.value,
                "show-icon": !_ctx.noIcon && !_ctx.$slots.inputicon
            }, {
                inputicon: _withCtx(() => [
                    _createVNode(SvgIcon, {
                        icon: "icon-calendar",
                        color: _ctx.iconColor,
                        height: _ctx.iconSize,
                        width: _ctx.iconSize
                    }, null, 8, ["color", "height", "width"])
                ]),
                _: 1
            }, 8, ["modelValue", "show-time", "icon-display", "min-date", "max-date", "pt", "hour-format", "date-format", "input-props", "show-icon"]));
        };
    }
});
